import React from 'react';
import '../../styles.scss';

import {configData} from "../../config.js";
import {fetchSigned, isRecentMessage} from "../../shared/Utilities.js"

/**
 * Renders the device alias table
 *
 * @copyright Roche 2025
 * @author Nick Draper
 */

class DeviceAlias extends React.Component {
  /**
   * Constructor 
   * 
   * @param props The properties passed
   */
  constructor(props) {
    super(props);
    this.state = {
      aliasLoaded: false,
      alias: [],
    };
  }

  /** Runs whenever the properties of the control are changed
   * @param prevProps The previous properties dictionary
   * @param prevState The previous state dictionary
   */
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.deviceId !== this.props.deviceId || prevProps.forceUpdate !== this.props.forceUpdate) {
      if (isRecentMessage(this.props.forceUpdate)) {
        if (this.props.deviceId !== null) {
          this.loadDeviceAlias(this.props.deviceId);
        } else {
          this.setState({
            aliasLoaded: false,
            alias: [],
          });
        }
      }
    }
  }

  
  /**
   * Loads the alias data to display for a device
   * @param {*} deviceId the device_id to load
   */
  loadDeviceAlias(deviceId) {
    console.log("loading device Aliases for ", deviceId);
    this.setState({ aliasLoaded: false});

    fetchSigned(configData.DEVICE_DETAILS_API_URL + "alias/" + deviceId + "/")
    .then(res => res.json())
    .then(
      (result) => {
        this.setState({ alias: result,
                        aliasLoaded: true});
      },
      // Note: it's important to handle errors here
      // instead of a catch() block so that we don't swallow
      // exceptions from actual bugs in components.
      (error) => {
        this.setState({
          error
        });
      }
    )
  }


    /**
   * Converts a camelCase string to Sentence Case
   * @param {*} inputText The input text in camelCase
   */
    convertCamelCaseToSentenceCase(inputText) {
      const result = inputText.replace(/([A-Z])/g, " $1");
      const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
      return finalResult;
    }

    
  /**
   * Render the section displaying the device aliases
   */
  renderAliasRow(row) {
    const keyEnding = row.dataSourceName;
    const style = {};
    if (row.count30D >= configData.INVESTIGATION_ROW_LIMIT) {
      style.backgroundColor = configData.COLOUR_INVESTIGATE;
    }
    

    return (
      <tr key={"AliasRow" + keyEnding} style={{"lineHeight": "1.4em"}}>
        <td key={"DataSourceCell" + keyEnding} 
            id={"DataSourcCell" + keyEnding} 
            valign="middle"
            style={Object.assign({}, style, {wordBreak:"normal"})}>
          {row.dataSourceName}
        </td>
        <td key={"SerialNumbersCell" + keyEnding} style={style} valign="middle">
          {row.serialNoList}
        </td>
        <td key={"totalCountCell" + keyEnding} style={style} valign="middle">
          {row.countAll}
        </td>
        <td key={"Count30dCell" + keyEnding} style={style} valign="middle">
          {row.count30D}
        </td>
        <td key={"dataset30dCell" + keyEnding} style={style} valign="middle">
          {row.dataset30D}
        </td>
      </tr>
    );
  }

  /**
   * Renders the controls
   * @returns The JSX of the controls
   */
  render() {
    let alias = this.state.alias;


    const style = { maxWidth:"97%", borderSpacing: "0px"};

    return (
      <table key={"DeviceAliasTable" + this.props.deviceId} style={{ style: style }} cellspacing="0">
        <thead>
          <tr style={{cellPadding:"0"}}>
            <th key={"blankHeaderspan"} style={{"textAlign":"left"}} colSpan={2}></th>
            <th key={"RowHeaderspan"} style={{"textAlign":"left"}} colSpan={2}>Rows</th>
            <th key={"DistinctHeaderspan"} style={{"textAlign":"left"}}>Distinct</th>
          </tr>
          <tr>
            <th key={"DataSourceHeader"} style={{"textAlign":"left"}}>Data Source</th>
            <th key={"SerialNumbersHeader"} style={{"textAlign":"left"}}>Serial Numbers</th>
            <th key={"TotalCountHeader"} style={{"textAlign":"left"}}>Total</th>
            <th key={"Count30dHeader"} style={{"textAlign":"left"}}>30d</th>
            <th key={"DSataset30dHeader"} style={{"textAlign":"left"}}>Datasets</th>
          </tr>
        </thead>
        <tbody loading={!this.state.aliasLoaded}>
          {alias.map((row) => this.renderAliasRow(row))}
        </tbody>
      </table>
    );

  }
}

DeviceAlias.defaultProps = {
  deviceId: null,
  forceUpdate: null,
}

export default DeviceAlias
